//This file will check if a workerUser is logged in and grant access to protected routes.
//It implemets the useWorkerAutoLogout hook to manage automatic logout for workers upon token expiration.
import { Navigate, Outlet } from "react-router-dom"
import { useAuthStatus } from "../hooks/useAuthStatus"
import Spinner from "./Spinner"

import useWorkerAutoLogout from "../hooks/useWorkerAutoLogout"


const PrivateWorkerRoute = () =>{

    useWorkerAutoLogout() // Activate auto-logout for worker users
    const {workerLoggedIn, checkingStatus} = useAuthStatus()

    if(checkingStatus){
        return <Spinner />
    }
    return workerLoggedIn ? <Outlet /> : <Navigate to='/workerLogin' />;


}


export default PrivateWorkerRoute

